<template>
    <b-form @submit.prevent="onSubmit">
        <div class="form-group row">
            <label for="form-field-current_password" class="col-lg-4 col-form-label" :class="{'text-right': !isMobile}">
                {{ $t('personal_data.current_password') }}
            </label>
            <div class="col-lg-8">
                <b-form-input id="form-field-current_password" v-model="form.current_password" type="password"
                              :state="validation.current_password.valid"></b-form-input>
                <b-form-invalid-feedback :state="validation.current_password.valid">
                    {{ validation.current_password.message }}
                </b-form-invalid-feedback>
            </div>
        </div>
        <div class="form-group row">
            <label for="form-field-password" class="col-lg-4 col-form-label" :class="{'text-right': !isMobile}">
                {{ $t('personal_data.new_password') }}
            </label>
            <div class="col-lg-8">
                <b-form-input id="form-field-password" v-model="form.password" type="password"
                              :state="validation.password.valid"></b-form-input>
                <b-form-invalid-feedback :state="validation.password.valid">
                    {{ validation.password.message }}
                </b-form-invalid-feedback>
            </div>
        </div>
        <div class="form-group row">
            <label for="form-field-password_confirmation" class="col-lg-4 col-form-label" :class="{'text-right': !isMobile}">
                {{ $t('personal_data.confirm_password') }}
            </label>
            <div class="col-lg-8">
                <b-form-input id="form-field-password_confirmation" v-model="form.password_confirmation" type="password"
                              :state="validation.password_confirmation.valid"></b-form-input>
                <b-form-invalid-feedback :state="validation.password_confirmation.valid">
                    {{ validation.password_confirmation.message }}
                </b-form-invalid-feedback>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-8 offset-sm-4">
                <button type="submit" class="btn btn-success">{{ $t('personal_data.save') }}
                </button>
            </div>
        </div>
    </b-form>
</template>

<script>
  import password from 'src/mixins/passwordComponent';

  export default {
    mixins: [password],
  };
</script>
